import { isEqual as compare } from 'lodash'

export const isEqual = (prev: any, next: any) => {
  return compare(prev, next)
}
